module.exports = __webpack_public_path__ + "img/logo2.1429db57.png";